export default {name:'户外家具',category:['建筑设计','室内'],content:{parasol:{name:'遮阳伞'},stool:{name:'凳'},'lounge chair':{name:'休闲椅'}}};